import { UserAgentHelper } from "./userAgentHelper";
import { DebugHelper } from "./debugHelper";
import registry from '@/registry';
import MeasureTextSizeService from './MeasureTextSizeService';

// 文字列ヘルパークラス
export class StringHelper {
    // 0埋めする
    public static zeroPadding(num: number | string, length: number) {
        var zero = "";
        for (var i = 0; i < length; ++i) {
            zero += "0";
        }

        return (zero + num).slice(-length);
    }

    // 文字が半角かどうか判定する
    public static isHankaku(text: string): boolean {
        // テキスト中の半角を削除する
        text = text.replace(/ /g, "");
        return text.match(/^[\x20-\x7e]*$/) != null;
    }

    // 文字が半角かどうかを判定する(半角カナも含める)
    public static isHankakuStrictly(text: string): boolean {
        var beforeStr = new Array(
            "ｧ",
            "ｨ",
            "ｩ",
            "ｪ",
            "ｫ",
            "ｬ",
            "ｭ",
            "ｮ",
            "ｯ",
            "ｰ",
            "ｳﾞ",
            "ｶﾞ",
            "ｷﾞ",
            "ｸﾞ",
            "ｹﾞ",
            "ｺﾞ",
            "ｻﾞ",
            "ｼﾞ",
            "ｽﾞ",
            "ｾﾞ",
            "ｿﾞ",
            "ﾀﾞ",
            "ﾁﾞ",
            "ﾂﾞ",
            "ﾃﾞ",
            "ﾄﾞ",
            "ﾊﾞ",
            "ﾋﾞ",
            "ﾌﾞ",
            "ﾍﾞ",
            "ﾎﾞ",
            "ﾊﾟ",
            "ﾋﾟ",
            "ﾌﾟ",
            "ﾍﾟ",
            "ﾎﾟ",
            "ｱ",
            "ｲ",
            "ｳ",
            "ｴ",
            "ｵ",
            "ｶ",
            "ｷ",
            "ｸ",
            "ｹ",
            "ｺ",
            "ｻ",
            "ｼ",
            "ｽ",
            "ｾ",
            "ｿ",
            "ﾀ",
            "ﾁ",
            "ﾂ",
            "ﾃ",
            "ﾄ",
            "ﾅ",
            "ﾆ",
            "ﾇ",
            "ﾈ",
            "ﾉ",
            "ﾊ",
            "ﾋ",
            "ﾌ",
            "ﾍ",
            "ﾎ",
            "ﾏ",
            "ﾐ",
            "ﾑ",
            "ﾒ",
            "ﾓ",
            "ﾔ",
            "ﾕ",
            "ﾖ",
            "ﾗ",
            "ﾘ",
            "ﾙ",
            "ﾚ",
            "ﾛ",
            "ﾜ",
            "ｦ",
            "ﾝ"
        );
        return (
            this.isHankaku(text) || beforeStr.indexOf(text) >= 0 || text == " "
        );
    }

    // 文字列の半角をすべて全角に変換する
    public static toEmQuadString(text: string): string {
        var result = text;

        // 半角英数字、記号
        result = result.replace(/[!-~]/g, s => {
            return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
        });

        // 半角スペース
        result = result.replace(/ /g, "　");

        // 半角カナ
        var beforeStr = new Array(
            "ｧ",
            "ｨ",
            "ｩ",
            "ｪ",
            "ｫ",
            "ｬ",
            "ｭ",
            "ｮ",
            "ｯ",
            "ｰ",
            "ｳﾞ",
            "ｶﾞ",
            "ｷﾞ",
            "ｸﾞ",
            "ｹﾞ",
            "ｺﾞ",
            "ｻﾞ",
            "ｼﾞ",
            "ｽﾞ",
            "ｾﾞ",
            "ｿﾞ",
            "ﾀﾞ",
            "ﾁﾞ",
            "ﾂﾞ",
            "ﾃﾞ",
            "ﾄﾞ",
            "ﾊﾞ",
            "ﾋﾞ",
            "ﾌﾞ",
            "ﾍﾞ",
            "ﾎﾞ",
            "ﾊﾟ",
            "ﾋﾟ",
            "ﾌﾟ",
            "ﾍﾟ",
            "ﾎﾟ",
            "ｱ",
            "ｲ",
            "ｳ",
            "ｴ",
            "ｵ",
            "ｶ",
            "ｷ",
            "ｸ",
            "ｹ",
            "ｺ",
            "ｻ",
            "ｼ",
            "ｽ",
            "ｾ",
            "ｿ",
            "ﾀ",
            "ﾁ",
            "ﾂ",
            "ﾃ",
            "ﾄ",
            "ﾅ",
            "ﾆ",
            "ﾇ",
            "ﾈ",
            "ﾉ",
            "ﾊ",
            "ﾋ",
            "ﾌ",
            "ﾍ",
            "ﾎ",
            "ﾏ",
            "ﾐ",
            "ﾑ",
            "ﾒ",
            "ﾓ",
            "ﾔ",
            "ﾕ",
            "ﾖ",
            "ﾗ",
            "ﾘ",
            "ﾙ",
            "ﾚ",
            "ﾛ",
            "ﾜ",
            "ｦ",
            "ﾝ"
        );
        var afterStr = new Array(
            "ァ",
            "ィ",
            "ゥ",
            "ェ",
            "ォ",
            "ャ",
            "ュ",
            "ョ",
            "ッ",
            "ー",
            "ヴ",
            "ガ",
            "ギ",
            "グ",
            "ゲ",
            "ゴ",
            "ザ",
            "ジ",
            "ズ",
            "ゼ",
            "ゾ",
            "ダ",
            "ヂ",
            "ヅ",
            "デ",
            "ド",
            "バ",
            "ビ",
            "ブ",
            "ベ",
            "ボ",
            "パ",
            "ピ",
            "プ",
            "ペ",
            "ポ",
            "ア",
            "イ",
            "ウ",
            "エ",
            "オ",
            "カ",
            "キ",
            "ク",
            "ケ",
            "コ",
            "サ",
            "シ",
            "ス",
            "セ",
            "ソ",
            "タ",
            "チ",
            "ツ",
            "テ",
            "ト",
            "ナ",
            "ニ",
            "ヌ",
            "ネ",
            "ノ",
            "ハ",
            "ヒ",
            "フ",
            "ヘ",
            "ホ",
            "マ",
            "ミ",
            "ム",
            "メ",
            "モ",
            "ヤ",
            "ユ",
            "ヨ",
            "ラ",
            "リ",
            "ル",
            "レ",
            "ロ",
            "ワ",
            "ヲ",
            "ン"
        );
        for (var i = 0; i < beforeStr.length; ++i) {
            result = result.replace(new RegExp(beforeStr[i], "g"), afterStr[i]);
        }

        return result;
    }

    // 文字変換テーブル
    private static readonly verticalTable1 = [
        "（",
        "）",
        "｛",
        "｝",
        "〔",
        "〕",
        "【",
        "】",
        "《",
        "》",
        "〈",
        "〉",
        "「",
        "」",
        "『",
        "』",
        "［",
        "］",
        "〖",
        "〗",
        "，",
        "、",
        "。",
        "—",
        "‒",
        "…",
        "‥",
        "ー"
    ];
    private static readonly verticalTable2 = [
        "︵",
        "︶",
        "︷",
        "︸",
        "︹",
        "︺",
        "︻",
        "︼",
        "︽",
        "︾",
        "︿",
        "﹀",
        "﹁",
        "﹂",
        "﹃",
        "﹄",
        "﹇",
        "﹈",
        "︗",
        "︘",
        "︐",
        "︑",
        "︒",
        "︱",
        "︲",
        "︙",
        "︰",
        "丨"
    ];

    // 文字列を縦書き文字に変更する
    public static toVerticalString(text: string): string {
        var result = text;
        var isBreak = false;

        if (text.length == 1) {
            for (var i = 0; i < this.verticalTable1.length; ++i) {
                if (text == this.verticalTable1[i]) {
                    result = this.verticalTable2[i];
                    isBreak = true;
                    break;
                }
            }

            if (!isBreak) {
                for (var j = 0; j < this.verticalTable2.length; ++j) {
                    if (text == this.verticalTable2[j]) {
                        result = this.verticalTable1[j];
                        isBreak = true;
                        break;
                    }
                }
            }
        }

        return result;
    }
    public static toVerticalStringAll(text: string) {
        var textArray = text.split("");
        var newText = "";
        for (var i = 0; i < textArray.length; ++i) {
            newText += this.toVerticalString(textArray[i]);
        }
        return newText;
    }

    // utf8array to str
    public static utf8ArrayToStr(array) {
        var out, i, len, c;
        var char2, char3;

        out = "";
        len = array.length;
        i = 0;
        while (i < len) {
            c = array[i++];
            switch (c >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    // 0xxxxxxx
                    out += String.fromCharCode(c);
                    break;
                case 12:
                case 13:
                    // 110x xxxx   10xx xxxx
                    char2 = array[i++];
                    out += String.fromCharCode(
                        ((c & 0x1f) << 6) | (char2 & 0x3f)
                    );
                    break;
                case 14:
                    // 1110 xxxx  10xx xxxx  10xx xxxx
                    char2 = array[i++];
                    char3 = array[i++];
                    out += String.fromCharCode(
                        ((c & 0x0f) << 12) |
                            ((char2 & 0x3f) << 6) |
                            ((char3 & 0x3f) << 0)
                    );
                    break;
            }
        }
        return out;
    }

    // str to utf8array
    public static strToUtf8Array(str: string) {
        var n = str.length;
        var idx = -1;
        var bytes: Array<number> = [];
        var i, c;

        for (i = 0; i < n; ++i) {
            c = str.charCodeAt(i);
            if (c <= 0x7f) {
                bytes[++idx] = c;
            } else if (c <= 0x7ff) {
                bytes[++idx] = 0xc0 | (c >>> 6);
                bytes[++idx] = 0x80 | (c & 0x3f);
            } else if (c <= 0xffff) {
                bytes[++idx] = 0xe0 | (c >>> 12);
                bytes[++idx] = 0x80 | ((c >>> 6) & 0x3f);
                bytes[++idx] = 0x80 | (c & 0x3f);
            } else {
                bytes[++idx] = 0xf0 | (c >>> 18);
                bytes[++idx] = 0x80 | ((c >>> 12) & 0x3f);
                bytes[++idx] = 0x80 | ((c >>> 6) & 0x3f);
                bytes[++idx] = 0x80 | (c & 0x3f);
            }
        }
        return new Uint8Array(bytes);
    }

    /**
     * SVG上でのテキストサイズをptから計算する
     *
     * @param str テキスト
     * @param fontSize
     * @param fontFamily
     * @param fontWeight normal / bold / "14px" etc.
     * @param fontStyle normal / italic
     * @param isVertical 縦書きかどうか
     */
    public static calcTextSizeOnSVGPt(
        str: string,
        fontSize: number,
        fontFamily: string = "",
        fontWeight: string = "normal",
        fontStyle: string = "normal",
        isVertical: boolean = false
    ): { width: number; height: number } {
        // ptをそのままpxとして扱うと小さすぎるので、10倍する
        var calc = this.calcTextSizeOnSVG(
            str,
            fontSize * 10,
            fontFamily,
            fontWeight,
            fontStyle,
            isVertical
        );

        // 1/10 して結果を返す
        return { width: calc.width / 10, height: calc.height / 10 };
    }

/**
     * SVG上でのテキストサイズをptから計算する
     *
     * @param str テキスト
     * @param fontSize
     * @param fontFamily
     * @param fontWeight normal / bold / "14px" etc.
     * @param fontStyle normal / italic
     * @param isVertical 縦書きかどうか
     */
    public static calcLineRects(
        str: string,
        fontSize: number,
        fontFamily: string = "",
        fontWeight: string = "normal",
        fontStyle: string = "normal"
    ) {
        // ptをそのままpxとして扱うと小さすぎるので、10倍する
        const measure: MeasureTextSizeService = registry.resolve('measure');
        let ret =  measure.measureLine(str, {
            size: fontSize * 10,
            family: fontFamily,
            weight: fontWeight,
            style: fontStyle
        });

        // 1/10 して結果を返す
        let rects : Array<any> = [];
        for(let i = 0; i < ret.rects.length; ++i) {
            rects.push({
                "x": ret.rects[i].x / 10,
                "y": ret.rects[i].y / 10,
                "width": ret.rects[i].width / 10,
                "height": ret.rects[i].height / 10,
            })
        }
        return { "rects": rects };
    }

    // SVG上でのテキストサイズを計算する
    // str : 計測文字d
    // fontSize : フォントサイズ
    // fontFamily : フォントファミリー指定
    // fontWeight : normal, 数値, bold
    // fontStyle : normal, italic
    // isVertical : 縦書きか
    private static calcTextSizeOnSVG(
        str: string,
        fontSize: number,
        fontFamily: string = "",
        fontWeight: string = "normal",
        fontStyle: string = "normal",
        isVertical: boolean = false
    ): { width: number; height: number } {
        if (str == " ") {
            // 半角スペースの場合
            if (isVertical) {
                // 縦書きの場合は"あ あ" - "ああ"を計算する
                var size0 = this.calcTextSizeOnSVGCore(
                    "あ あ",
                    fontSize,
                    fontFamily,
                    fontWeight,
                    fontStyle,
                    isVertical
                );
                var size1 = this.calcTextSizeOnSVGCore(
                    "ああ",
                    fontSize,
                    fontFamily,
                    fontWeight,
                    fontStyle,
                    isVertical
                );

                return {
                    width: size1.width,
                    height: size0.height - size1.height
                };
            } else {
                // 横書きの場合は"8 8" - "88"を計算する
                var size2 = this.calcTextSizeOnSVGCore(
                    "8 8",
                    fontSize,
                    fontFamily,
                    fontWeight,
                    fontStyle,
                    isVertical
                );
                var size3 = this.calcTextSizeOnSVGCore(
                    "88",
                    fontSize,
                    fontFamily,
                    fontWeight,
                    fontStyle,
                    isVertical
                );

                return {
                    width: size2.width - size3.width,
                    height: size3.height
                };
            }
        } else if (str == "j" && !isVertical) {
            // "j"は文字サイズが若干左に寄るので、 "aja" - "aa" を計算する。
            var size4 = this.calcTextSizeOnSVGCore(
                "aja",
                fontSize,
                fontFamily,
                fontWeight,
                fontStyle,
                isVertical
            );
            var size5 = this.calcTextSizeOnSVGCore(
                "aa",
                fontSize,
                fontFamily,
                fontWeight,
                fontStyle,
                isVertical
            );

            return { width: size4.width - size5.width, height: size4.height };
        } else {
            if (
                UserAgentHelper.getBrowser() == "edge" ||
                UserAgentHelper.getBrowser() == "ie"
            ) {
                var size = this.calcTextSizeOnSVGCore(
                    str,
                    fontSize,
                    fontFamily,
                    fontWeight,
                    fontStyle,
                    isVertical
                );
                if (str == "　" && (size.width <= 0 || size.height <= 0)) {
                    // Edgeの古いバージョン,IEで、全角スペースがサイズ0と判断されることがあるので対応
                    DebugHelper.trace(
                        "Edge/IE : CalcTextSize fullwidth space is fixed."
                    );
                    var size4 = this.calcTextSizeOnSVGCore(
                        "あ　あ",
                        fontSize,
                        fontFamily,
                        fontWeight,
                        fontStyle,
                        isVertical
                    );
                    var size5 = this.calcTextSizeOnSVGCore(
                        "ああ",
                        fontSize,
                        fontFamily,
                        fontWeight,
                        fontStyle,
                        isVertical
                    );

                    if (isVertical) {
                        return {
                            width: size4.width,
                            height: size4.height - size5.height
                        };
                    } else {
                        return {
                            width: size4.width - size5.width,
                            height: size4.height
                        };
                    }
                }
                return size;
            } else {
                return this.calcTextSizeOnSVGCore(
                    str,
                    fontSize,
                    fontFamily,
                    fontWeight,
                    fontStyle,
                    isVertical
                );
            }
        }
    }

    private static calcTextSizeOnSVGCore(
        str: string,
        fontSize: number,
        fontFamily: string = "",
        fontWeight: string = "normal",
        fontStyle: string = "normal",
        isVertical: boolean = false
    ): { width: number; height: number } {
        if(!UserAgentHelper.isElectron())
        {
            //! Web版では以前の処理を使用する。
            //! Chromeで縦書きのとき MeasureTextSizeService 内の writingMode = "vertical-rl" が落ちてしまったので
            return this.calcTextSizeOnSVGCore_Org(str, fontSize, fontFamily, fontWeight, fontStyle, isVertical);
        }
        else
        {
            const measure: MeasureTextSizeService = registry.resolve('measure');
            return measure.measure(str, {
                size: fontSize,
                family: fontFamily,
                weight: fontWeight,
                style: fontStyle
            }, isVertical);
        }
    }

    private static calcTextSizeOnSVGCore_Org(str : string, fontSize : number, fontFamily : string = "", fontWeight : string = "normal", fontStyle : string = "normal", isVertical : boolean = false) : { width : number, height : number }
    {    
        var width = 0;
        var height = 0;

        // SVG作成
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.style.position = "fixed";
        svg.style.left = "100px";
        svg.style.top = "100px";
        svg.style.width = "100px";
        svg.style.height = "100px";
        document.body.appendChild(svg);

        // text作成
        var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.textContent = str;
        text.setAttributeNS(null, "x", "0");
        text.setAttributeNS(null, "y", "0");
        text.setAttributeNS(null, "font-size", fontSize + "");
        text.setAttributeNS(null, "writing-mode", isVertical ? "tb" : "lr");
        text.style.fontFamily = fontFamily;
        text.style.fontSize = fontSize + "";
        text.style.fontWeight = fontWeight;
        text.style.fontStyle = fontStyle;
        text.style.whiteSpace = "pre";
        if(isVertical) { text.style.writingMode = "vertical-rl"; }
        if(isVertical) { text.style.webkitWritingMode = "vertical-rl"; }
        svg.appendChild(text);

        // サイズ計測
        var bounds = text.getBBox();
        if(isVertical && !this.isHankaku(str) && UserAgentHelper.getBrowser() == "safari")
        {
            width = bounds.height;
            height = bounds.width;
        }
        else
        {
            width = bounds.width;
            height = isVertical ? bounds.height : (2 * Math.abs(bounds.y) - bounds.height) * 1.2;
        }
        // フォントによってはうまく計算されないことがあるので、
        // 計算がおかしい場合はフォントサイズの1.1倍として返す
        if(width <= 0) width = fontSize * 1.1;
        if(height <= 0) height = fontSize * 1.1;

        // 削除
        svg.removeChild(text);
        document.body.removeChild(svg);

        return { width : width, height : height };
    }

    public static replaceLast(text : string, search : string, replace : string)
    {
        let newText = text;
        let index = text.lastIndexOf(search);
        if (index >= 0) {
            let before = text.substr(0, index);
            let after = text.substr(index + search.length);
            newText = before + replace + after;
        }
        return newText;
    }

    private static localeCompareSupportsLocales() 
    {
        try 
        {
            'a'.localeCompare​('b', 'i');
        } 
        catch (e) 
        {
            return e instanceof Error && e.name === 'RangeError';
        }
        return false;
      }

    public static compareString(t1 : string, t2 :string)
    {
        if(StringHelper.localeCompareSupportsLocales())
        {
            return t1.localeCompare(t2, 'ja');
        }
        else
        {
            return StringHelper.compareStringOrigin(t1, t2);
        }
    }

    private static compareStringOrigin(t1 : string, t2 :string)
    {
        t1 = StringHelper.zenkaku2Hankaku(t1).toLowerCase();
        t2 = StringHelper.zenkaku2Hankaku(t2).toLowerCase();
        if(t1 < t2) return -1;
        if(t1 > t2) return 1;
        return 0;
    }

    // 全角アルファベット・数字を半角に変換する
    public static zenkaku2Hankaku(str : string)
    {
        return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248));
    }

    // 半角アルファベット・数字を全角に変換する
    public static hankaku2Zenkaku(str : string)
    {
        return str.replace(/[A-Za-z0-9]/g, s => String.fromCharCode(s.charCodeAt(0) + 65248));
    }
}
